/* sc-guide.js — sommaire adaptatif (H2+H3) + scroll-spy pour le template page.guide. */
(function () {
  function build() {
    var body = document.querySelector('.guide-body'),
        nav = document.querySelector('.guide-toc__nav'),
        here = document.querySelector('.guide-toc__here'),
        toc = document.querySelector('.guide-toc');
    if (!nav) { return false; }
    if (nav.dataset.built) { return true; }
    if (!body) { return false; }
    var heads = [].slice.call(body.querySelectorAll('h2, h3'));
    if (!heads.length) { return false; } // contenu pas encore prêt
    nav.dataset.built = '1';

    var ul = document.createElement('ul');
    ul.className = 'toc-root';
    var items = [], curH2 = null, curSub = null;
    heads.forEach(function (h, i) {
      if (!h.id) { h.id = 'sec-' + i; }
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent;
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' }); // scroll fluide (respecte scroll-margin-top)
        if (history.replaceState) { history.replaceState(null, '', '#' + h.id); }
        if (window.innerWidth < 900) { toc.removeAttribute('open'); }
      });
      li.appendChild(a);
      var item = { h: h, a: a, li: li, parent: null };
      if (h.tagName === 'H2') {
        li.className = 'toc-h2'; ul.appendChild(li);
        curSub = document.createElement('ul'); curSub.className = 'toc-sub'; li.appendChild(curSub);
        curH2 = item;
      } else {
        li.className = 'toc-h3'; (curSub || ul).appendChild(li); item.parent = curH2;
      }
      items.push(item);
    });
    nav.appendChild(ul);

    function setActive(h) {
      var active = null;
      items.forEach(function (it) { if (it.h === h) { active = it; } it.a.classList.remove('is-active'); it.li.classList.remove('is-open'); });
      if (!active) { return; }
      active.a.classList.add('is-active');
      var openH2 = active.parent || active;
      if (openH2) { openH2.li.classList.add('is-open'); }
      if (here) { here.textContent = h ? h.textContent : ''; }
    }
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { setActive(e.target); } });
    }, { rootMargin: '-12% 0px -72% 0px', threshold: 0 });
    items.forEach(function (it) { obs.observe(it.h); });
    setActive(heads[0]);
    if (toc && window.innerWidth < 900) { toc.removeAttribute('open'); } // replié sur mobile uniquement
    return true;
  }

  function init() { build(); }

  // Cale le sommaire (sticky top) + les ancres (scroll-margin) sous l'en-tête sticky réel du thème.
  function setHeaderOffset() {
    var hdr = document.querySelector('.pageheader--sticky') ||
              document.querySelector('.section-header') ||
              document.querySelector('header');
    var hh = hdr ? hdr.offsetHeight : 0;
    if (hh) { document.documentElement.style.setProperty('--guide-top', (hh + 30) + 'px'); }
  }
  function boot() { init(); setHeaderOffset(); }

  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  window.addEventListener('load', boot);
  window.addEventListener('resize', setHeaderOffset);
  document.addEventListener('shopify:section:load', init);
  // Robustesse : reconstruit si la section est (ré)injectée — hot-reload theme dev, navigation AJAX.
  // build() est idempotent (sort tôt si déjà construit ou si pas de contenu).
  setInterval(init, 500);
})();
